import { useGlobalAuth } from '@headbox-ui/auth-hook'
import { FC, ReactNode } from 'react'
import { LOGIN_SERVICE } from '../../Constants'

type AuthenticatorProps ={
  children: ReactNode
} & ({
  requireAuth: false
  redirectToLogin?: false
  guestComponent?: undefined
} | {
  requireAuth: true
  redirectToLogin: true
  guestComponent?: undefined
} | {
  requireAuth: true
  redirectToLogin?: false
  guestComponent: ReactNode
}
)
const Authenticator: FC<AuthenticatorProps> = ({ children, requireAuth, redirectToLogin, guestComponent }) => {
  const { authenticated, user } = useGlobalAuth()

  if ((authenticated && Boolean(user)) || !requireAuth) {
    return <>{children}</>
  }
  if (redirectToLogin) {
    window.location.replace(LOGIN_SERVICE)
    return null
  }

  return <>{guestComponent}</>
}

export default Authenticator
